var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3DCardboard = function Svg3DCardboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.403 11.25v25.5h-10.9l-3.288-6.34c-1.004-1.936-3.002-3.139-5.215-3.139s-4.211 1.203-5.215 3.139l-3.288 6.34h-10.9v-25.5zm3-3H1.597v31.5h15.724l4.127-7.958c.526-1.014 1.539-1.52 2.552-1.52s2.026.507 2.552 1.52l4.127 7.958h15.724z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.726,
    cy: 23.578,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.274,
    cy: 23.578,
    r: 4.6,
    transform: "rotate(-76.714 34.277 23.578)"
  })))));
};
export default Svg3DCardboard;